import Alert from "react-bootstrap/Alert";

const NoItems = () => {
  return (
    <Alert variant="info" className="mt-3">
      <Alert.Heading>No Action Items</Alert.Heading>
      <p>There are currently no action items to show.</p>
    </Alert>
  );
};

export default NoItems;
